export default __webpack_public_path__ + "static/media/logoVecom.6d6b3b64.png";